<template>
  <svg
    width="13"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.94807 7.31355L10.7271 12.0926L11.4342 11.3855L6.65518 6.60645L11.4342 1.82743L10.7271 1.12033L5.94807 5.89934L0.827589 0.778857L0.120482 1.48596L5.24096 6.60644L0.120481 11.7269L0.827588 12.434L5.94807 7.31355Z"
      fill="#3F3844"
    />
  </svg>
</template>